import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { AuthService } from '@gyselroth/angular-auth';
import { combineLatest, of } from 'rxjs';
import { filter, switchMap, take } from 'rxjs/operators';

import { GraphAuthService } from './graph-auth.service';
import { OrganizationConfigService } from '../../organization/services/organizationConfig.service';

export const msalSessionResolver: ResolveFn<void> = () => {
  const authService = inject(AuthService);
  const graphAuthService = inject(GraphAuthService);
  const organizationConfigService = inject(OrganizationConfigService);

  if (organizationConfigService.organization.loginType !== 'azure') {
    return;
  }

  return combineLatest([authService.loggedIn$, authService.user$]).pipe(
    /*
     * The AuthGuard has already succeeded at this point.
     * We only wait until the user object has been restored.
     */
    filter(([, user]) => user !== undefined),
    take(1),

    switchMap(([loggedIn, user]) => {
      const loginHint = user?.preferred_username;

      if (!loggedIn || !loginHint) {
        return of(void 0);
      }

      return graphAuthService.restoreSession(loginHint);
    })
  );
};
